import { faDiamond } from "@jewlr/sharp-solid-svg-icons/faDiamond"
import { Box, Flex, Typography, FontAwesomeIcon } from "@jewlr/storybook/core"
import PropTypes from "prop-types"
import styled from "styled-components"

import { jewlr_t } from "helpers/application"

const Grid = styled(Box).attrs((props) => ({
  display: { _: "flex", tablet: "grid" },
  flexDirection: "column",
  gap: { _: 5, desktop: 3 },
  gridTemplateColumns: { _: "repeat(2, 1fr)", desktop: "repeat(4, 1fr)" },
  mb: { _: 2, tablet: "60px" },
  pb: props.inModal ? 0 : { _: 4, tablet: "60px" },
  textAlign: "left",
}))``

const StepBox = styled(Box).attrs({
  maxWidth: { desktop: "280px" },
})``

const getSteps = () => [
  {
    color: "primary",
    description: `Create your Gift Preview Video in the ${jewlr_t(
      "cart"
    )} and place order.`,
    title: "CREATE",
  },
  {
    color: "pinkTourmaline",
    description: "Review your video from the confirmation page or email.",
    title: "REVIEW",
  },
  {
    color: "peridot",
    description: "Share your video via text, email, WhatsApp or Messenger.",
    title: "SHARE",
  },
  {
    color: "citrine",
    description: `We handcraft and ${jewlr_t(
      "terms.ship"
    )} your order – it is delivered in days.`,
    title: "SHIP",
  },
]

const HowItWorks = ({ inModal }) => (
  <Grid inModal={inModal} role="list">
    {getSteps().map((step, i) => (
      <StepBox key={i} role="listitem">
        <Flex alignItems="center" mb={{ _: "10px", tablet: "20px" }}>
          <FontAwesomeIcon
            color={step.color}
            fontSize="24px"
            icon={faDiamond}
            mr="10px"
          />
          <Typography {...(inModal && { fontSize: "18px" })} variant="h3">
            <span aria-hidden>{i + 1}. </span>
            {step.title}
          </Typography>
        </Flex>
        <Box>
          <Typography variant={inModal ? "body-sm" : "body"}>
            {step.description}
          </Typography>
        </Box>
      </StepBox>
    ))}
  </Grid>
)

HowItWorks.propTypes = {
  inModal: PropTypes.bool,
}

export default HowItWorks
